import Logo from "../../components/Logo";

const styles = {
  container:
    "w-[min(60rem,90%)] mx-auto px-6 py-12 font-sans text-gray-800 leading-relaxed",
  h1: "text-3xl font-bold mb-2 text-gray-900",
  h2: "text-xl font-semibold mt-10 mb-4 text-gray-900",
  p: "mb-4 text-base",
  ul: "list-disc pl-6 mb-4 space-y-2",
  li: "text-base",
  updated: "text-sm text-gray-500 mb-8",
  link: "text-blue-600 underline hover:text-blue-800",
};

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className={styles.container}>
        <div className="mb-10">
          <Logo />
        </div>

        <h1 className={styles.h1}>Privacy Policy</h1>
        <p className={styles.updated}>Effective Date: Feb 25, 2026</p>

        <h2 className={styles.h2}>1. Introduction</h2>
        <p className={styles.p}>
          This Privacy Policy describes how The SHOW, LLC (“Company,” “we,” “us,” or “our”)
          collects, uses, processes, discloses, stores, and protects personal information
          when you access or use The SHOW mobile application and related services
          (“Application”).
        </p>
        <p className={styles.p}>
          By accessing or using the Application, you acknowledge that you have read
          and understood this Privacy Policy.
        </p>

        <h2 className={styles.h2}>2. Eligibility – 18+ Only</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>
            The Application is strictly intended for individuals eighteen (18) years of age or older.
          </li>
          <li className={styles.li}>
            By creating an account, you represent that you are at least 18 years old and
            have legal capacity to enter binding agreements.
          </li>
          <li className={styles.li}>
            We do not knowingly collect personal data from individuals under 18.
            If discovered, such data will be deleted and accounts may be terminated.
          </li>
        </ul>

        <h2 className={styles.h2}>3. Categories of Information Collected</h2>

        <p className={styles.p}><strong>Identifiers</strong></p>
        <ul className={styles.ul}>
          <li className={styles.li}>Name</li>
          <li className={styles.li}>Email address</li>
          <li className={styles.li}>Username / Alias / Account name</li>
          <li className={styles.li}>IP address</li>
          <li className={styles.li}>Device identifiers</li>
          <li className={styles.li}>Online identifiers</li>
          <li className={styles.li}>Social media user ID</li>
        </ul>

        <p className={styles.p}><strong>Commercial Information</strong></p>
        <ul className={styles.ul}>
          <li className={styles.li}>Transaction records</li>
          <li className={styles.li}>Purchase history</li>
          <li className={styles.li}>Subscription data</li>
        </ul>

        <p className={styles.p}><strong>Internet / Electronic Activity</strong></p>
        <ul className={styles.ul}>
          <li className={styles.li}>Browsing history within the Application</li>
          <li className={styles.li}>Search history</li>
          <li className={styles.li}>Interaction data</li>
          <li className={styles.li}>Advertisement interaction</li>
          <li className={styles.li}>Log files</li>
          <li className={styles.li}>Embedded media interaction</li>
        </ul>

        <p className={styles.p}><strong>Protected Classification Data</strong></p>
        <ul className={styles.ul}>
          <li className={styles.li}>Age (for eligibility verification)</li>
          <li className={styles.li}>Gender (optional)</li>
        </ul>

        <p className={styles.p}><strong>Geolocation Data</strong></p>
        <ul className={styles.ul}>
          <li className={styles.li}>Approximate device location</li>
          <li className={styles.li}>Precise location (if enabled and consented)</li>
        </ul>

        <p className={styles.p}><strong>User-Generated Content</strong></p>
        <ul className={styles.ul}>
          <li className={styles.li}>Photos</li>
          <li className={styles.li}>Videos</li>
          <li className={styles.li}>Captions</li>
          <li className={styles.li}>Messages</li>
          <li className={styles.li}>Comments</li>
          <li className={styles.li}>Reports submitted</li>
        </ul>

        <p className={styles.p}><strong>Moderation & Enforcement Data</strong></p>
        <ul className={styles.ul}>
          <li className={styles.li}>Reports of objectionable content</li>
          <li className={styles.li}>Enforcement actions</li>
          <li className={styles.li}>Account restrictions</li>
          <li className={styles.li}>Suspension records</li>
        </ul>

        <h2 className={styles.h2}>4. Sources of Data</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>Direct user input</li>
          <li className={styles.li}>Automatic tracking technologies</li>
          <li className={styles.li}>Third-party login providers</li>
          <li className={styles.li}>Analytics services</li>
          <li className={styles.li}>Advertising partners</li>
        </ul>

        <h2 className={styles.h2}>5. Purposes of Processing</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>Operate and maintain the Application</li>
          <li className={styles.li}>Provide core platform functionality</li>
          <li className={styles.li}>Moderate and review content</li>
          <li className={styles.li}>Review reports within 24 hours</li>
          <li className={styles.li}>Enforce Terms of Service</li>
          <li className={styles.li}>Prevent fraud, abuse, and illegal activity</li>
          <li className={styles.li}>Improve user experience</li>
          <li className={styles.li}>Conduct analytics</li>
          <li className={styles.li}>Provide targeted advertising (where permitted)</li>
          <li className={styles.li}>Comply with legal obligations</li>
        </ul>

        <h2 className={styles.h2}>6. Content Moderation and Safety</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>Zero tolerance for objectionable content or abusive users</li>
          <li className={styles.li}>Automated filtering systems</li>
          <li className={styles.li}>AI-assisted detection</li>
          <li className={styles.li}>Human moderation review</li>
          <li className={styles.li}>All valid reports reviewed within 24 hours</li>
          <li className={styles.li}>Right to remove content, suspend, or permanently terminate accounts</li>
          <li className={styles.li}>Right to report illegal activity to authorities</li>
        </ul>

        <h2 className={styles.h2}>7. Legal Bases (GDPR / UK GDPR)</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>Consent</li>
          <li className={styles.li}>Contractual necessity</li>
          <li className={styles.li}>Legitimate interests</li>
          <li className={styles.li}>Legal obligations</li>
          <li className={styles.li}>Vital interests</li>
        </ul>

        <h2 className={styles.h2}>8. Sharing of Personal Information</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>Hosting providers</li>
          <li className={styles.li}>Analytics providers</li>
          <li className={styles.li}>Fraud prevention services</li>
          <li className={styles.li}>Security vendors</li>
          <li className={styles.li}>Email service providers</li>
          <li className={styles.li}>Advertising networks</li>
          <li className={styles.li}>Professional advisors</li>
          <li className={styles.li}>Law enforcement</li>
        </ul>
        <p className={styles.p}>We do not sell personal information.</p>

        <h2 className={styles.h2}>9. Targeted Advertising</h2>
        <p className={styles.p}>
          We may use advertising technologies to display relevant ads, measure
          effectiveness, and analyze impressions. Users may opt out where required by law.
        </p>

        <h2 className={styles.h2}>10. Data Retention</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>While your account is active</li>
          <li className={styles.li}>As required by law</li>
          <li className={styles.li}>For moderation records</li>
          <li className={styles.li}>To resolve disputes</li>
          <li className={styles.li}>To enforce agreements</li>
        </ul>

        <h2 className={styles.h2}>11. Security Measures</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>Encryption in transit</li>
          <li className={styles.li}>Access control restrictions</li>
          <li className={styles.li}>Monitoring systems</li>
          <li className={styles.li}>Security audits</li>
        </ul>
        <p className={styles.p}>
          However, no method of transmission is 100% secure.
        </p>

        <h2 className={styles.h2}>12. Your Privacy Rights</h2>
        <ul className={styles.ul}>
          <li className={styles.li}>Access</li>
          <li className={styles.li}>Correct</li>
          <li className={styles.li}>Delete</li>
          <li className={styles.li}>Restrict processing</li>
          <li className={styles.li}>Data portability</li>
          <li className={styles.li}>Opt out of targeted advertising</li>
          <li className={styles.li}>Limit use of sensitive data</li>
        </ul>
        <p className={styles.p}>
          Requests: <a href="mailto:support@theshowapp.com" className={styles.link}>
            support@theshowapp.com
          </a>
        </p>

        <h2 className={styles.h2}>13. Cookies & Tracking</h2>
        <p className={styles.p}>
          We use cookies and similar technologies for security, analytics,
          advertising, and user preferences.
        </p>

        <h2 className={styles.h2}>14. Social Logins</h2>
        <p className={styles.p}>
          If you use third-party login providers, we may receive profile information
          as permitted by that provider.
        </p>

        <h2 className={styles.h2}>15. Do Not Track</h2>
        <p className={styles.p}>
          We do not respond to DNT signals.
        </p>

        <h2 className={styles.h2}>16. International Transfers</h2>
        <p className={styles.p}>
          Data may be processed outside your country of residence.
        </p>

        <h2 className={styles.h2}>17. California Shine The Light</h2>
        <p className={styles.p}>
          California residents may request disclosure of data shared for direct marketing.
        </p>

        <h2 className={styles.h2}>18. Changes to Policy</h2>
        <p className={styles.p}>
          We reserve the right to update this Privacy Policy.
        </p>
      </div>

      <footer className="border-t border-gray-200 py-8 text-center text-sm text-gray-500">
        © 2026 The SHOW, LLC. All rights reserved. —{" "}
        <a href="mailto:support@theshowapp.com" className={styles.link}>
          support@theshowapp.com
        </a>
      </footer>
    </div>
  );
}